import React, { useEffect, useState } from "react";
import "./UploadVideo.scss";
import { fetchUsersByCategorie } from "../services/apiUsers";
import { fetchContentAll } from "../services/apiCategorie";
import FilmUploadPanel from "./catalogAdmin/FilmUploadPanel";
import SerializedUploadPanel from "./catalogAdmin/SerializedUploadPanel";
import CategoryAdminPanel from "./catalogAdmin/CategoryAdminPanel";

const TABS = [
  { id: "films", label: "Films" },
  { id: "series", label: "Séries" },
  { id: "documentaries", label: "Documentaires" },
  { id: "categories", label: "Catégories" },
];

export default function UploadVideo() {
  const [users, setUsers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [currentTab, setCurrentTab] = useState("films");

  const refreshBaseData = async () => {
    const [usersData, categoriesData] = await Promise.all([
      fetchUsersByCategorie(1),
      fetchContentAll(),
    ]);

    setUsers(usersData);
    setCategories(categoriesData);
  };

  useEffect(() => {
    refreshBaseData();
  }, []);

  return (
    <div className="page-content">
      <div className="upload-shell">
        <div className="upload-shell__header">
          <h1 className="upload-title">Centre d’ajout du catalogue</h1>
          <p className="upload-helper">
            Ajoute des films, des séries et des documentaires selon la structure du backend, avec saisons et épisodes.
          </p>
        </div>

        <div className="tabs tabs--catalog">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              className={`tab ${currentTab === tab.id ? "active" : ""}`}
              onClick={() => setCurrentTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {currentTab === "films" ? <FilmUploadPanel users={users} categories={categories} /> : null}
        {currentTab === "series" ? <SerializedUploadPanel type="serie" users={users} categories={categories} /> : null}
        {currentTab === "documentaries" ? (
          <SerializedUploadPanel type="documentaire" users={users} categories={categories} />
        ) : null}
        {currentTab === "categories" ? <CategoryAdminPanel onRefresh={refreshBaseData} /> : null}
      </div>
    </div>
  );
}
